<template>
  <div class="content-container">
    <div class="table-wrapper">
      <a-row type="flex" justify="space-between" style="margin-bottom: 20px">
        <a-col :span="12">
          <a-form-model layout="inline">
            <a-form-model-item
              class="search-work-style"
              :label="$t('form.common.field.workName.label')"
            >
              <a-input
                v-model="searchForm.name"
                :placeholder="$t('form.common.field.workName.message')"
                style="width: 200px"
              />
              <a-button
                type="primary"
                style="margin-left: 15px"
                @click="search"
                >{{ $t(`actionTitles.search`) }}</a-button
              >
            </a-form-model-item>
          </a-form-model>
        </a-col>
        <a-col :span="10" :offset="2">
          <a-row class="btn-group-style" style="text-align: right">
            <a-button
              v-if="folderDepthList.length<2"
              type="primary"
              :style="{ margin: '0px 15px' }"
              @click="createFolder"
              >{{ $t(`actionTitles.newFolder`) }}</a-button
            >

            <a-dropdown placement="bottomCenter">
              <a-menu slot="overlay" @click="handleChange" style="width: 120px">
                <a-menu-item key="delete">{{
                  $t("actionTitles.delete")
                }}</a-menu-item>
                <a-menu-item key="moveTo">{{
                  $t("actionTitles.moveTo")
                }}</a-menu-item>
              </a-menu>
              <a-button style="margin-left: 8px">
                {{ $t("actionTitles.moreOperate") }}
                <a-icon type="down" />
              </a-button>
            </a-dropdown>
          </a-row>
        </a-col>
      </a-row>

      <clear-selected
        alert-type="error"
        :show="selectedRowKeys.length > 0"
        :selectedCount="selectedRowKeys.length"
        @clear="onClearSelected"
      />
      <a-row>
        <a-breadcrumb>
          <a-breadcrumb-item>
            <a @click="queryByPid(0)">{{ $t("moduleTitles.root") }}</a>
          </a-breadcrumb-item>
          <a-breadcrumb-item
            v-for="(item, index) in folderDepthList"
            :key="index"
          >
            <a @click="queryByPid(item.id)">{{ item.name }}</a>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </a-row>
      <a-table
        :row-selection="rowSelection"
        :data-source="tableData"
        :rowKey="rowKey"
        :pagination="pagination"
        @change="handleTableChange"
        :customRow="customRow"
      >
        <a-table-column
          key="name"
          :title="$t('table.common.thead.name')"
          data-index="name"
        >
          <template slot-scope="text, record">
            <a-row
              v-if="record.release === undefined"
              type="flex"
              align="middle"
            >
              <a-icon
                v-if="record.dir_id == undefined"
                type="folder"
                theme="filled"
                style="
                  color: #1790ff;
                  font-size: 40px;
                  margin-right: 10px;
                  cursor: pointer;
                "
                @click="toFolder(record)"
              />
              <img
                v-else
                :src="record.thumb_path"
                alt
                style="width: 40px; margin-right: 10px; cursor: pointer"
                @click="toTour(record)"
              />

              <div v-if="record.dir_id == undefined">
                <span @click="toFolder(record)" class="toFolder">{{
                  record.name
                }}</span>
              </div>
              <div v-else>
                <span @click="toTour(record)" class="toFolder">{{
                  record.name
                }}</span>
                <br />
                <span>{{ record.regoin_name }}</span>
              </div>
            </a-row>
            <a-row v-else type="flex" align="middle">
              <a-col :span="14" class="release">
                <img :src="record.thumb_path" alt />
                <div class="workName">
                  <span>{{ record.name }}</span>
                  <br />
                  <span>{{ record.create_time }}</span>
                </div>
              </a-col>
              <a-col class="progress" :span="10">
                <img src="@/assets/img/publishing.gif" />
                <p>{{ $t("message.workAwait") }}</p>
              </a-col>
            </a-row>
          </template>
        </a-table-column>
        <a-table-column
          key="customer_name"
          :title="$t('table.work.thead.customerName')"
          data-index="customer_name"
          align="center"
        >
          <template slot-scope="text, record">
            <div v-if="record.customer_name">
              <span>{{ record.customer_name }}</span>
              <br />
              <span>{{ record.customer_phone }}</span>
            </div>
            <span v-else>-</span>
          </template>
        </a-table-column>
        <a-table-column
          key="total_browse"
          :title="$t('table.work.thead.readCount')"
          data-index="total_browse"
          :sorter="true"
          align="center"
        >
          <template slot-scope="text, record">{{
            record.total_browse != undefined ? record.total_browse : "-"
          }}</template>
        </a-table-column>
        <a-table-column
          key="is_public"
          :title="$t('table.common.thead.state')"
          data-index="is_public"
          :filters="filters"
          align="center"
        >
          <template slot-scope="text, record">{{
            record.is_public != undefined
              ? $t(`enum.workIsPublic.${record.is_public}`)
              : "-"
          }}</template>
        </a-table-column>
        <a-table-column
          key="create_time"
          :title="$t('table.common.thead.updateTime')"
          :sorter="true"
          data-index="create_time"
          align="center"
        >
          <template slot-scope="text, record">
            <span>{{ record.create_time ? record.create_time : "-" }}</span>
          </template>
        </a-table-column>
        <a-table-column
          key="recommend"
          :title="$t('table.common.thead.recommend')"
          :sorter="true"
          data-index="recommend"
          align="center"
        >
          <template slot-scope="text, record">
            <div v-if="record.dir_id != undefined">
              <a-icon
                v-if="record.recommend == 0"
                @click="recommend(record)"
                style="color: red"
                type="close"
              />
              <a-icon
                v-else
                style="color: green"
                @click="recommend(record)"
                type="check"
              />
            </div>
            <div v-else>-</div>
          </template>
        </a-table-column>

        <a-table-column
          key="operate"
          :title="$t('table.common.thead.operate')"
          align="center"
        >
          <template slot-scope="text, record">
            <div v-if="record.release === undefined">
              <span v-if="record.dir_id == undefined">
                <a @click="handleRename(record)">{{
                  $t("actionTitles.rename")
                }}</a>
                <a-divider type="vertical" />

                <a-popconfirm
                  placement="top"
                  :ok-text="$t('actionTitles.yes')"
                  :cancel-text="$t('actionTitles.no')"
                  @confirm="handleDelete(record.id, 'dir')"
                >
                  <template slot="title">{{
                    $t("message.deleteHint")
                  }}</template>
                  <a style="color: red">{{ $t("actionTitles.delete") }}</a>
                </a-popconfirm>
              </span>
              <span v-else>
                <a @click="share(record)">{{ $t("actionTitles.share") }}</a>
                <a-divider type="vertical" />
                <a @click="onClickEdit(record)">{{
                  $t("actionTitles.edit")
                }}</a>
                <a-divider type="vertical" />
                <a @click="offlineDownload(record)">{{
                  $t("actionTitles.offlineDownload")
                }}</a>
                <a-divider type="vertical" />
                <a @click="talk(record.id)">{{ $t("actionTitles.talk") }}</a>
                <a-divider type="vertical" />
                <!-- 刪除確認框-->
                <a-popconfirm
                  placement="top"
                  :ok-text="$t('actionTitles.yes')"
                  :cancel-text="$t('actionTitles.no')"
                  @confirm="handleDelete(record.id, 'pano')"
                >
                  <template slot="title">{{
                    $t("message.softDeleteHint")
                  }}</template>
                  <a style="color: red">{{ $t("actionTitles.delete") }}</a>
                </a-popconfirm>
              </span>
            </div>
            <div v-else>
              <span v-if="record.dir_id == undefined">
                <a-popconfirm
                  placement="top"
                  :ok-text="$t('actionTitles.yes')"
                  :cancel-text="$t('actionTitles.no')"
                  @confirm="deleteAsync(record.id)"
                >
                  <template slot="title">{{
                    $t("message.deleteHint")
                  }}</template>
                  <a style="color: red">{{ $t("actionTitles.delete") }}</a>
                </a-popconfirm>
              </span>
            </div>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
      :title="modelTitle"
      :visible="exitVisible"
      @ok="save"
      @cancel="exitVisible = false"
      :ok-text="$t('actionTitles.save')"
      :cancel-text="$t('actionTitles.cancel')"
      keyboard
    >
      <a-form-model
        ref="ruleForm"
        :model="form"
        :form="form"
        :rules="rules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 15 }"
        :okText="$t('actionTitles.ascertain')"
        :cancelText="$t('actionTitles.cancel')"
      >
        <a-form-model-item ref="name" :label="$t('edit.name')" prop="name">
          <a-input
            v-model="form.name"
            :placeholder="$t('form.common.field.createFolder.placeholder')"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal
      v-model="treeVisible"
      :title="$t('actionTitles.moveTo')"
      :ok-text="$t('actionTitles.save')"
      :cancel-text="$t('actionTitles.cancel')"
      @ok="moveTo"
    >
      <a-directory-tree
        :loadedKeys="loadedKeys"
        :replaceFields="{ children: 'children', title: 'name', key: 'id' }"
        :load-data="onLoadData"
        :tree-data="treeData"
        :selectedKeys="selectedKeys"
        @select="onSelect"
      />
    </a-modal>

    <a-modal
      v-model="shareVisible"
      :title="$t('actionTitles.share')"
      :width="800"
      :destroyOnClose="true"
      @ok="() => (this.shareVisible = false)"
    >
      <share :work-id="shareWorkId"></share>
    </a-modal>

    <a-modal
      v-model="talkVisible"
      :title="$t('actionTitles.talk')"
      :width="850"
      :destroyOnClose="true"
      :footer="null"
      @ok="() => (this.talkVisible = false)"
    >
      <a-table
        :data-source="talkData.data"
        :loading="talkLoading"
        :pagination="talkPagination"
        rowKey="id"
        @change="handleTalkTableChange"
      >
        <a-table-column
          key="nickname"
          :title="$t('table.common.thead.reviewer')"
          data-index="nickname"
          align="center"
        >
          <template slot-scope="text, record">
            <div class="talk-reviewer">
              <img
                :src="
                  record.head_img
                    ? record.head_img
                    : '/ssr/static/images/default_avatar.jpg'
                "
                alt=""
                style="width: 40px; margin-right: 10px"
              />
              <a style="color: #000" :title="record.nickname">{{
                record.nickname.length > 4
                  ? record.nickname.slice(0, 4) + "..."
                  : record.nickname
              }}</a>
            </div>
          </template>
        </a-table-column>

        <a-table-column
          key="content"
          :title="$t('table.common.thead.content')"
          data-index="content"
          align="center"
          width="50%"
        ></a-table-column>
        <a-table-column
          key="create_time"
          :title="$t('table.common.thead.createTime')"
          data-index="create_time"
          align="center"
        ></a-table-column>
        <a-table-column
          key="operate"
          :title="$t('table.common.thead.operate')"
          align="center"
        >
          <template slot-scope="text, record">
            <span>
              <a-popconfirm
                :cancelText="$t('actionTitles.cancel')"
                :okText="$t('actionTitles.confirm')"
                :title="$t('message.softDeleteHint')"
                @confirm="() => deleteTalk(record.id)"
              >
                <a href="javascript:;" style="color: red">
                  {{ $t(`actionTitles.delete`) }}
                </a>
              </a-popconfirm>
            </span>
          </template>
        </a-table-column>
      </a-table>
    </a-modal>
  </div>
</template>

<style scoped>
.toFolder:hover {
  cursor: pointer;
  color: #1890ff;
}
.release .ant-row-flex-middle {
  margin-top: 20px;
}
.release img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  float: left;
}
.release .workName {
  float: left;
}
.release .ant-progress-outer {
  width: 80%;
}
.release .progress {
  font-size: 12px;
  text-align: center;
}
.talk-reviewer{
  display: flex;
  align-items: center;
}
</style>
<script>
import path from "path";
import ClearSelected from "../../components/ClearSelected";
import {
  getWorkDetail,
  getWorkList,
  createFolder,
  softDelete,
  getTreeDir,
  getFolderDepth,
  moveDir,
  releaseWork,
  deleteAsync,
  recommend,
  queryTalk,
  delTalk,
} from "@/api/work";
import Share from "@/components/Share";

import JSZip from "jszip";
import FileSaver from "file-saver";
import { getFile } from "@/utils/downloadFile";
import { baseUrl } from "@/config";
import { download } from "@/utils/offlineDownload";

export default {
  data() {
    return {
      selectedRowKeys: [],
      selectedRows: [],
      searchForm: {
        pid: 0,
        name: "",
        is_public: [],
        order: [],
      },
      pageResult: {},
      loading: false,
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      searchParam: {},
      renameVisible: false,
      exitVisible: false,
      form: {
        name: "",
      },
      modelTitle: "",
      rules: {
        name: [
          {
            required: true,
            message: this.$t("form.folder").field.name.message,
            trigger: "blur",
          },
        ],
      },
      treeVisible: false,
      selectedKeys: [],
      treeData: [{ id: 0, name: this.$t("moduleTitles.root") }],
      folderDepthList: [],
      selectDirIds: [],
      loadedKeys: [],
      releaseList: [],
      timeout: undefined,
      tableData: [],
      filters: [
        {
          text: `${this.$t("enum.workIsPublic[1]")}`,
          value: "1",
        },
        {
          text: `${this.$t("enum.workIsPublic[0]")}`,
          value: "0",
        },
      ],
      shareVisible: false,
      shareWorkId: 0,
      shareThumbPath: "",
      talkVisible: false, //說一說
      talkData: [],
      talkLoading: false,
      queryTalkParams: {
        wid: "",
        current_page: 1,
        per_page: 10,
      },
      talkPagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      moveLoading:false
    };
  },
  components: { ClearSelected, Share },
  computed: {
    count() {
      return this.expand ? 11 : 7;
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: (record) => ({
          props: {
            disabled: record.release != undefined ? true : false, // 禁用項
            name: record.name,
          },
        }),
      };
    },
  },
  mounted() {
    this.loadData();
    this.getReleaseWork();
    this.timeout = setInterval(() => {
      this.getReleaseWork();
    }, 10000);
  },
  destroyed() {
    //頁面銷毀 銷毀定時任務
    window.clearInterval(this.timeout);
  },
  methods: {
    recommend(record) {
      console.log("查看用戶");
      let userType = this.$store.getters.userInfo.type;
      if (userType == 1) {
        let workInfo = { id: record.id };
        workInfo.recommend = record.recommend == 1 ? 0 : 1;
        recommend(workInfo).then((res) => {
          this.loadData();
        });
      }
    },
    onClickEdit(record) {
      //this.$router.push({ path: "/edit", query: { id: record.id } });
      window.location.href = "/edit?id=" + record.id;
    },
    onLoadData(treeNode) {
      return new Promise((resolve) => {
        if (treeNode.dataRef.children) {
          resolve();
          return;
        }else{
          setTimeout(() => {
            getTreeDir({ pid: treeNode.dataRef.id }).then((res) => {
              if (res.code && res.data.length) {
                // 找出已選的資料夾ID
                let dir = [];
                this.selectedRows.forEach((item) => {
                  if (item.dir_id == undefined) {
                    dir.push(item.id);
                  }
                });
                // 清除自己所屬之資料夾
                let data = res.data.filter((item) => {
                  if (!dir.includes(item.id)) {
                    return item;
                  }
                });

                if(data.length) {
                  treeNode.dataRef.children = data
                }else{
                  treeNode.dataRef.isLeaf = true
                }
              } else {
                treeNode.dataRef.isLeaf = true;
              }
              this.treeData = [...this.treeData];
              resolve();
            });
          }, 1);
        }
      });
    },
    getReleaseWork() {
      releaseWork().then((res) => {
        if (res.data.length <= 0) {
          window.clearInterval(this.timeout);
        }
        this.loadData();
        this.releaseList = res.data.map((item) => {
          item.release = 1;
          return item;
        });
        this.mergeTableData();
      });
    },
    mergeTableData() {
      if (
        this.pageResult.records == undefined ||
        this.pageResult.records.length <= 0
      ) {
        this.pagination.pageSize = this.releaseList.length;
        this.tableData = [...this.releaseList];
      } else if (this.releaseList.length <= 0) {
        this.tableData = [...this.pageResult.records];
      } else {
        this.pagination.pageSize = 10 + this.releaseList.length;
        this.tableData = [...this.releaseList, ...this.pageResult.records];
      }
    },
    deleteAsync(id) {
      deleteAsync({ id: id }).then((res) => {
        if (res.code) {
          this.$message.success(this.$t("message.deleteSuccess"));
          this.getReleaseWork();
        }
      });
    },
    onSelect(selectedKeys, info) {
      this.selectedKeys = selectedKeys;
    },
    rowKey(record) {
      if (record.release === undefined) {
        if (record.dir_id === undefined) {
          return "dir:" + record.id;
        } else {
          return record.id;
        }
      } else {
        return "release:" + record.id;
      }
    },
    customRow(record, index) {
      let _self = this;
      return {
        on: {
          dblclick: function () {
            if (record.dir_id == undefined) {
              _self.searchForm.pid = record.id;
              _self.pagination.current_page = 1;
              _self.loadData();
            }
          },
        },
      };
    },
    toFolder(record) {
      this.searchForm.pid = record.id;
      this.pagination.current_page = 1;
      this.pagination.current = 1;
      this.loadData();
    },
    handleRename(row) {
      this.form = { ...{} };
      setTimeout(() => {
        this.$refs["ruleForm"].resetFields();
        this.form = { ...row };
      }, 0);
      this.exitVisible = true;
      this.modelTitle = this.$t("model.folder.renameTitle");
      // this.form = {...row};
    },
    save() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          createFolder(this.form)
            .then((res) => {
              this.loadData();
              this.$message.success(this.$t("message.saveSuccess"));
              this.exitVisible = false;
            })
            .catch((err) => {
              this.$message.error(err);
            });
        }
      });
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    handleTableChange(pagination, filters, sorter) {
      console.log("11");
      this.pagination = pagination;
      if (Object.keys(filters).length > 0) {
        this.searchForm.is_public = filters.is_public;
      }
      if (Object.keys(sorter).length > 0) {
        let field = sorter.field;
        let orderStr = sorter.order == "ascend" ? "asc" : "desc";

        let order = {};
        order[field] = orderStr;
        this.searchForm.order = order;
        console.log(this.searchForm.order);
      }
      this.loadData();
    },
    handleDelete(id, type) {
      let deletelist = [{ id: id, type: type }];
      softDelete(deletelist).then((res) => {
        this.$message.success(this.$t("message.deleteSuccess"));
        this.loadData();
      });
    },
    loadData() {
      this.loading = true;
      this.searchParam = {
        ...this.searchForm,
        ...{ current_page: this.pagination.current, per_page: 10 },
      };

      getWorkList(this.searchParam)
        .then((ret) => {
          this.loading = false;
          this.pageResult = ret.data;
          // this.tableData = ret.data.records;
          this.pagination.total = ret.data.total;
          this.selectedRowKeys = [];
          this.selectedRows = [];
          this.mergeTableData();
        })
        .catch(() => {
          this.loading = false;
        });
      getFolderDepth({ id: this.searchParam.pid }).then((res) => {
        if (res.code) {
          this.folderDepthList = res.data;
        }
      });
    },
    createFolder() {
      setTimeout(() => {
        this.$refs["ruleForm"].resetFields();
        this.form = { ...{ name: "", pid: 0 } };
        this.form.pid = this.searchForm.pid;
      }, 0);
      this.exitVisible = true;
      this.modelTitle = this.$t("model.folder.addTitle");
    },
    handleChange(val) {
      if (this.selectedRows.length <= 0) {
        this.$message.warning(this.$t("message.selectHint"));
        return;
      }
      let list = [];
      let dirList = [];
      let panoList = [];
      let dirIds = [];
      this.selectedRows.forEach((item) => {
        if (item.dir_id == undefined) {
          dirList.push({ id: item.id, type: "dir" });
          dirIds.push(item.id);
        } else {
          panoList.push({ id: item.id, type: "pano" });
        }
      });
      list = [...dirList, ...panoList];
      if (val.key === "delete") {
        softDelete(list).then((res) => {
          this.$message.success(this.$t("message.deleteSuccess"));
          this.loadData();
        });
      } else if (val.key === "offlineDownload") {
        //離線下載
      } else {
        //移動到
        this.selectDirIds = dirIds;
        (this.treeData = [{ id: 0, name: this.$t("moduleTitles.root") }]),
          (this.treeVisible = true);
        this.selectedKeys = [];
        this.loadedKeys = [];
      }
    },
    queryByPid(pid) {
      this.searchForm.pid = pid;
      this.loadData();
    },
    async moveTo() {
      if (this.selectedKeys.length <= 0) {
        this.$message.warning(this.$t("message.moveSelectHint"));
        return;
      }
      if(this.moveLoading) return false
      this.moveLoading = true
      let dir = []
      let pano = []
      this.selectedRows.forEach((item) => {
        if (item.dir_id == undefined) {
          dir.push(item.id);
        }else {
          pano.push(item.id);
        }
      });
      if(dir.length){
        //取得第二和第三層資料夾ID
        let target = this.treeData[0].children
        let allDeep3ID = []
        let allDeep2ID = []
        if(target){
          for(let i = 0;i<target.length;i++){
            allDeep2ID.push(target[i].id)
            if(target[i]?.children) {
              for(let j = 0;j<target[i].children.length;j++){
                allDeep3ID.push(target[i].children[j].id)
              }
            }
          }
        }
        //取得移動目標是否包含資料夾
        let payload = {
          current_page:1,
          name:'',
          is_public: [],
          order:[],
          per_page:10,
          pid:0,
        }
        let hasDir = false
        for(let index = 0;index<dir.length;){
          payload.pid = dir[index]
          await getWorkList(payload)
            .then((res) => {
              if (res.code === 1) {
                hasDir = res.data.records.some((item)=> item.pid)
              }
            })
            .catch((error) => {
              console.log('error',error)
          });
          if(hasDir){
            break
          }else{
            // 延遲callAPI時間
            await new Promise(resolve => {
              setTimeout(() => {
                index++
                resolve()
              }, 200)
            });
          }
        }
        //當移動作品包括資料夾時，移動後不可超出三層資料夾
        if((allDeep3ID.includes(this.selectedKeys[0])) || (allDeep2ID.includes(this.selectedKeys[0]) && hasDir)) {
          this.$message.warning(this.$t("message.moveFail"))
          this.moveLoading = false
          return false
        }
      }
      let param = { to: this.selectedKeys[0], dir, pano };
      moveDir(param).then((res) => {
        this.$message.success(this.$t("message.moveSuccess"));
        this.treeVisible = false;
        this.loadData();
        this.moveLoading = false
      });
    },
    copy(item) {
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.setAttribute("value", item.thumb_path);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$message.success(this.$t("message.copySuccess"));
      }
      document.body.removeChild(input);
    },
    share(item) {
      this.shareWorkId = item.uuid;
      this.shareThumbPath = item.thumb_path;
      this.shareVisible = true;
    },
    toTour(item) {
      const { href } = this.$router.resolve({
        path: (item.type==2 ? "/live/" : "/tour/") + `${item.uuid}`,
      });
      window.open(href, "_blank");
    },
    offlineDownload(record) {
      download(record);
    },
    search() {
      this.reset();
      this.loadData();
    },
    reset() {
      this.pagination.current = 1;
    },
    //說一說
    onClickTalk() {
      this.talkLoading = true;
      let queryTalkParams = {
        ...this.queryTalkParams,
        ...{
          current_page: this.talkPagination.current,
          per_page: this.talkPagination.pageSize,
        },
      };
      queryTalk(queryTalkParams)
        .then((res) => {
          if (res.code === 1 && res.data.data.length) {
            this.talkLoading = false;
            this.talkData = res.data;
            this.talkPagination.total = res.data.total;
            this.talkVisible = true;
          } else {
            this.talkLoading = false;
            this.talkPagination.total = res.data.total;
            this.talkVisible = true;
            this.talkData = [];
          }
        })
        .catch((err) => {
          this.talkLoading = false;
          console.log("queryTalk err=", err);
        });
    },
    deleteTalk(Tid) {
      delTalk({ id: Tid })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success(this.$t("message.deleteSuccess"), 2, () => {
              this.talkPagination.current = 1;
              this.onClickTalk();
            });
          }
        })
        .catch((err) => {
          console.log("delTalk err =", err);
        });
    },
    handleTalkTableChange(pagination, filters, sorter) {
      this.talkPagination = pagination;
      // if (Object.keys(sorter).length > 0) {
      //   let field = sorter.field;
      //   let orderStr = sorter.order == "ascend" ? "asc" : "desc";
      //   let order = {};
      //   order[field] = orderStr;
      //   this.queryTalkParams.order = order;
      // }
      this.onClickTalk();
    },
    talk(wid) {
      this.queryTalkParams.wid = wid;
      this.talkPagination.current = 1;
      this.onClickTalk();
    },
  },
};
</script>

<style lang="less" scoped>
</style>
